// File: frontend/src/views/private/admin/UPS.js

import React from 'react';
import AdminPageTemplate from '../../../components/layout/AdminPageTemplate';
import { TrendingUp } from 'lucide-react';

const UPS = () => {
  return (
    <AdminPageTemplate
      title="Underwriting & Pricing Management"
      subtitle="Configure underwriting rules and pricing models"
      icon={TrendingUp}
      showComingSoon={true}
    />
  );
};

export default UPS;